// extracted by mini-css-extract-plugin
export default {"heading_text":"events_future_line_heading_text__tgh10"};